/* eslint-disable react/display-name */
import React, { useState } from 'react';
import { Select } from 'antd';
import Item from 'antd/lib/list/Item';

const { Option } = Select;

interface RegionEditProps extends React.HTMLAttributes<HTMLElement> {
  onChange?: any;
  defaultValue?: any;
  style?: any;
  dataSource: any;
  showSearch?:any;
  placeholder?: string;
  valueKey: string;
  allOptionName?: string;
  allOptionValue?: string;
  mode?: string;
  value?: string;
}

const Dropdown: React.FC<RegionEditProps> = ({
  onChange,
  defaultValue,
  style,
  dataSource,
  showSearch,
  placeholder,
  valueKey,
  allOptionName,
  allOptionValue="",
  mode,
  value
}) => {
  return (
    <Select
      mode={mode as "multiple" | "tags"}
      onChange={onChange}
      defaultValue={defaultValue}
      placeholder={placeholder}
      style={{ border: '1px solid #d9d9d9', ...style}}
      {...value ? {value} : {}}
      showSearch={showSearch}
    >
      {allOptionName && (
        <Option selected={defaultValue === allOptionValue} key="all" value={allOptionValue}>
          {allOptionName}
        </Option>
      )}
      {dataSource &&
        dataSource.map((item: any) => (
          item && <Option key={item.id || item} value={valueKey ? item[valueKey] : item}>
            {valueKey ? item[valueKey] : item}
          </Option>
        ))}
    </Select>
  );
};
export default Dropdown;
